export default user => ({
  login: true,
  name: user.displayName,
  email: user.email,
  emailVerified: user.emailVerified,
  uid: user.uid
})



// WEBPACK FOOTER //
// ./src/utils/userInfo.js